// src/components/Layout.jsx

import Header from "../components/Header"; // Assuming you have a Header component
import Footer from "../components/Footer"; // Assuming you have a Footer component
import ScrollToTop from "../components/ScrollToTop";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <main>{children}</main>{" "}
      {/* Page-specific content will be rendered here */}
      <Footer />
    </>
  );
};

export default Layout;
